(ns app.front.view.complaint.new-case-view
  (:require [app.domain.address.model :as address-model]
            [app.domain.blackout.model :as blackout-model]
            [app.domain.booking.model :as booking-model]
            [app.domain.group.config.model :as config-model]
            [app.domain.group.model :as group-model]
            [app.domain.group.permit-type-config.model :as ptc-model]
            [app.domain.inspection.model :as inspection-model]
            [app.domain.util :as du]
            [app.domain.workspace.model :as workspace-model]
            [app.front.entities :as entities]
            [app.front.process :as process]
            [app.front.ui :as ui]
            [app.front.ui.content-switcher :as ui-cs]
            [app.front.ui.modal :as ui-modal]
            [app.front.ui.multi-select :as ui-ms]
            [app.front.ui.photo-select :as photo-select]
            [app.front.ui.rich-text :as ui-rt]
            [app.front.ui.select :as ui-select]
            [app.front.util :refer [for-frag]]
            [app.front.view.case-description.subs :as desc-subs]
            [app.front.view.complaint.subs :as complaint-subs]
            [app.front.view.inspections.booking-dialog :as booking-dialog]
            [app.front.view.inspections.booking-utils :as booking-utils]
            [clojure.string :as str]
            [core.db.entity-api :as entity-api]
            [core.db.entity.util :as eu]
            [core.front.carbon :as cc]
            [core.front.date-util :as date-util]
            [core.front.event :refer [<sub >evt]]
            [core.front.feature-flags :as ff]
            [core.user.model :as user-model]
            [core.util.util :as util]
            [potpuri.core :as p]
            [re-frame.core-instrumented :as rf]
            [schema-tools.core :as st]))

(defn close-modal []
  (>evt [::clear-state]))


(defn close-optional-modal-fn [default-vals? default-slot-id execution-id default-inspection-id template-id
                               selected-assignee assignee-changed? inspection-type-changed?]
  (if default-vals?
    (let [date (js/Date.)]
      (>evt [::disable-default-optional-vals])
      (when assignee-changed?
        (>evt [::process/signal
               execution-id
               (if (= "unassigned" (:id selected-assignee))
                 [:process.signal/remove-assignee]
                 [:process.signal/set-assignee
                  {:assignee (:db/id selected-assignee)}])
               {:notify {:success :workspace/successfully-assigned}}]))
      (if inspection-type-changed?
        (do (>evt [::process/signal
                   execution-id
                   [:process.signal/remove-inspection
                    {:inspection-id default-inspection-id}]])
            (>evt [::create-inspection template-id date default-slot-id]))
        (>evt [::create-booking date default-slot-id])))
    (>evt [::clear-state])))


(rf/reg-event-fx ::get-complaint-for-case-creation
  (fn [{:keys [db]} [_ complaint-id]]
    {:db           (-> (update-in db [::new-case-data ::new-case-complaint-ids] conj complaint-id)
                       (assoc-in [::new-case-data ::fetching-complaints?] true))
     :comm/command {:command          :complaint/get
                    :data             {:complaint-id complaint-id}
                    :method           :get
                    :on-success       [::get-complaint-for-case-creation.success]
                    :finally-dispatch [::get-complaint-for-case-creation.done]}}))


(rf/reg-event-fx ::pre-select-all-complaint-photos
  (fn [_ [_ photos]]
    {:fx (map (fn [photo] [:dispatch [::add-case-photo photo]]) photos)}))

(rf/reg-event-fx ::get-complaint-for-case-creation.success
  (fn [_ [_ status data]]
    (let [entities          (vals data)
          complaint-photos  (filter #(and (= (:entity/type %) :entity.type/file)
                                          (= (:file/category %) :file.category/complaint-photo))
                                    entities)
          complainant-email (some :complaint/complainer-email entities)]
      {:fx [[:dispatch [::entities/merge-entity-db status data]]
            [:dispatch [::update-new-case-complainants-list true complainant-email]]
            [:dispatch [::pre-select-all-complaint-photos (map :db/id complaint-photos)]]]})))


(rf/reg-event-db ::get-complaint-for-case-creation.done
  (fn [db _]
    (assoc-in db [::new-case-data ::fetching-complaints?] false)))


(rf/reg-event-fx ::create-case
  (fn [{:keys [db]} [_ skip-inspection? params {:keys [authority-group-id]} success-msg]]
    {:db           (update db ::new-case-data assoc
                           ::creating-case? true
                           ::fetching-assignees? true
                           ::fetching-inspections? true
                           ::default-optional-vals? true
                           ::authority-group-id authority-group-id
                           ::create-modal-open? false)
     :comm/command {:command    :workspace/create
                    :data       params
                    :notify     {:success success-msg}
                    :on-success [::create-case.success skip-inspection?]
                    :on-error   [::error-handler]}}))


(rf/reg-event-fx ::create-case.success
  (fn [{:keys [db]} [_ skip-inspection? status response]]
    (let [workspace-id (entities/property-of-some-in-apply-changes :workspace/id response)]
      {:db (update db ::new-case-data assoc ::creating-case? false ::workspace-id workspace-id)
       :fx [[:dispatch [::entities/apply-changes status response]]
            (when-not skip-inspection? [:dispatch [::open-optional-params-modal]])
            ;; time-slots are a part of the :inspection/get-inspections request
            [:comm/command {:command    :workspace/get
                            :data       {:workspace/id workspace-id
                                         :find-related [:entity.type/time-slot]}
                            :on-success [::workspace-fetch.success skip-inspection? workspace-id]
                            :on-error   [::error-handler]}]
            [:comm/command {:command    :group/authority-users
                            :method     :get
                            :data       {:workspace-id workspace-id}
                            :on-success [::assignee-fetch.success workspace-id]
                            :on-error   [::error-handler]}]]})))


(rf/reg-event-fx ::workspace-fetch.success
  (fn [{:keys [db]} [_ skip-inspection? workspace-id status response]]
    (let [ents        (:entities response)
          entity-vals (vals ents)
          workspace   (p/find-first entity-vals #(= (:workspace/id %) workspace-id))
          execution   (p/find-first entity-vals #(and (= (:entity/parent %) (:db/id workspace))
                                                      (= (:entity/type %) :entity.type/execution)))
          group-id    (-> db ::new-case-data ::authority-group-id)
          auth-group  (p/find-first entity-vals {:db/id group-id})
          tz          (:group/tz auth-group)]
      {:db           (update db ::new-case-data assoc
                             ::execution-id (:db/id execution)
                             ::timezone tz)
       :fx           [[:dispatch [::entities/merge-entity-db status ents]]
                      [:dispatch [::assign-case]]]
       :comm/command {:command    :inspection/get-inspections
                      :method     :get
                      :data       {:group-id group-id}
                      :on-success [::inspection-fetch.success skip-inspection?]
                      :on-error   [::error-handler]}})))


(rf/reg-event-fx ::assignee-fetch.success
  (fn [{:keys [db]} [_ _ status response]]
    {:db       (update db ::new-case-data assoc ::assignees (vals response) ::fetching-assignees? false)
     :dispatch [::entities/merge-entity-db status response]}))


(defn slots-for-day [date time-slots]
  (let [weekday (some-> date .getDay)]
    (->> time-slots
         (filter #(= (:time-slot/weekday %) weekday))
         (sort-by :time-slot/start-hour))))


(rf/reg-event-fx ::inspection-fetch.success
  (fn [{:keys [db]} [_ skip-inspection? status {:keys [entities]}]]
    (let [inspection-types     (->> entities
                                    (filter (eu/is-type-fn :entity.type/inspection-template-kind))
                                    (filter (du/in-state-fn :inspection.template.kind.state/active)))
          inspection-templates (->> entities
                                    (filter (eu/is-type-fn :entity.type/inspection-template))
                                    (filter (du/in-state-fn :inspection.template.state/active)))
          default-type-id      (-> inspection-types first :db/id)
          default-template-id  (->> inspection-templates
                                    (filter #(= (:entity/parent %) default-type-id))
                                    first
                                    :db/id)
          default-date         (js/Date.)
          time-slots           (filter #(= (:entity/type %) :entity.type/time-slot) entities)
          default-slot-id      (-> (slots-for-day default-date time-slots) first :db/id)]
      {:db (update db ::new-case-data assoc
                   ::inspection-types inspection-types
                   ::inspection-templates inspection-templates
                   ::fetching-inspections? false)
       :fx [[:dispatch [::entities/merge-entity-db status (du/entities->entity-db entities)]]
            (if (or skip-inspection?
                    (nil? default-template-id))
              [:dispatch [::move-to-case-without-inspections]]
              [:dispatch [::create-inspection default-template-id default-date default-slot-id]])]})))


(defn clear-state-fx [db]
  (let [cleanup-event (get-in db [::new-case-data ::cleanup-event])
        workspace-id  (get-in db [::new-case-data ::workspace-id])
        cleanup-event (cond-> cleanup-event
                        (and cleanup-event workspace-id) (conj {:case-workspace-id workspace-id}))]
    {:fx (cond-> [[:dispatch [::desc-subs/clear-description-data]]
                  [:dispatch [::clear-new-case-data]]]
           cleanup-event (conj [:dispatch cleanup-event]))}))


(rf/reg-event-fx ::clear-state
  (fn [{:keys [db]} _]
    (clear-state-fx db)))


(rf/reg-event-fx ::error-handler
  (fn [_ _]
    {:dispatch [::clear-state]}))


(rf/reg-event-fx ::assign-case
  (fn [{:keys [db]} _]
    (let [user-id           (-> db :session/user :db/id)
          execution-id      (-> db ::new-case-data ::execution-id)
          selected-assignee (-> db ::new-case-data ::selected-new-case-assignee)]
      {:dispatch [::process/signal
                  execution-id
                  (if (= "unassigned" (:id selected-assignee))
                    [:process.signal/remove-assignee]
                    [:process.signal/set-assignee {:assignee (or (:db/id selected-assignee)
                                                                 user-id)}])
                  {:on-error [::error-handler]}]})))


(rf/reg-event-fx ::create-inspection
  (fn [{:keys [db]} [_ template-id date default-slot-id]]
    (let [execution-id (-> db ::new-case-data ::execution-id)]
      {:dispatch [::process/signal
                  execution-id
                  [:process.signal/add-inspection
                   {:verdict-section-id nil
                    :template-id        template-id
                    :add-as-active?     true}]
                  {:on-success [::create-booking date default-slot-id]
                   :on-error   [::error-handler]}]})))


(rf/reg-event-fx ::create-booking
  (fn [{:keys [db]} [_ date default-slot-id _ response]]
    (let [inspection            (p/find-first (vals response) #(contains? % :inspection/descriptions))
          new-inspection-id     (->> response (filter #(= (val %) inspection)) flatten first)
          default-vals?         (-> db ::new-case-data ::default-optional-vals?)
          default-inspection-id (-> db ::new-case-data ::default-inspection-id)
          selected-date         (-> db ::new-case-data ::selected-date)
          selected-time-slot    (-> db ::new-case-data ::selected-time-slot)
          payload               (merge (booking-utils/payload-time-data [{:date         (or selected-date
                                                                                            date)
                                                                          :time-slot-id (or (:db/id selected-time-slot)
                                                                                            default-slot-id)}])
                                       {:inspection-id (or new-inspection-id
                                                           default-inspection-id)})
          execution-id          (-> db ::new-case-data ::execution-id)]
      (cond (and default-vals? new-inspection-id)
            {:db (assoc-in db [::new-case-data ::default-inspection-id] new-inspection-id)}
            (and date selected-time-slot)
            {:dispatch [::process/signal
                        execution-id
                        [:process.signal/create-booking
                         payload]
                        {:on-success [::dispatch-booking]
                         :on-error   [::error-handler]}]}
            :else
            {:dispatch [::process/signal
                        execution-id
                        [:process.signal/create-booking
                         payload]
                        {:on-success [::inspections-and-bookings-created]
                         :on-error   [::error-handler]}]}))))


(rf/reg-event-fx ::dispatch-booking
  (fn [{:keys [db]} [_ _ response]]
    (let [booking-id   (first (keys response))
          to-user-id   (-> db :session/user :db/id)
          execution-id (-> db ::new-case-data ::execution-id)
          time-slot    (-> db ::new-case-data ::selected-time-slot)
          date         (-> db ::new-case-data ::selected-date)
          tz           (-> db ::new-case-data ::timezone)
          start-time   (date-util/date-at-time-in-tz date
                                                     (:time-slot/start-hour time-slot)
                                                     (:time-slot/start-minute time-slot)
                                                     tz)
          end-time     (date-util/date-at-time-in-tz date
                                                     (:time-slot/end-hour time-slot)
                                                     (:time-slot/end-minute time-slot)
                                                     tz)]
      {:dispatch [::process/signal
                  execution-id
                  [:process.signal/dispatch-booking
                   (util/mmap to-user-id start-time end-time booking-id)]
                  {:on-success [::inspections-and-bookings-created]
                   :on-error   [::error-handler]}]})))


(rf/reg-event-fx ::inspections-and-bookings-created
  (fn [{:keys [db]} _]
    (cond (-> db ::new-case-data ::move-to-case?)
          {:route/push {:route :view/workspace :params {:workspace-id (-> db ::new-case-data ::workspace-id)}}}
          (not (-> db ::new-case-data ::default-optional-vals?))
          (close-modal))))

(rf/reg-event-fx ::move-to-case-without-inspections
  (fn [{:keys [db]} _]
    {:route/push {:route :view/workspace :params {:workspace-id (-> db ::new-case-data ::workspace-id)}}}))

(rf/reg-event-db ::clear-new-case-data
  (fn [db _]
    (dissoc db ::new-case-data)))

(defn open-create-modal-db [db cleanup-event]
  (cond-> (-> db
              (dissoc ::desc-subs/case-description)
              (assoc-in [::new-case-data ::create-modal-open?] true)
              (p/dissoc-in [::new-case-data ::cleanup-event]))
    cleanup-event (assoc-in [::new-case-data ::cleanup-event] cleanup-event)))

(rf/reg-event-fx ::open-create-modal
  (fn [{:keys [db]} [_ cleanup-event]]
    {:db (open-create-modal-db db cleanup-event)}))


(rf/reg-event-db ::open-optional-params-modal
  (fn [db _]
    (assoc-in db [::new-case-data ::optional-params-modal-open?] true)))


(rf/reg-event-db ::save-complaint-for-case-creation
  (fn [db [_ complaint]]
    (assert (entity-api/entity? complaint) "complaint must be an entity")
    (let [email (:complaint/complainer-email complaint)]
      (cond-> db
        true  (assoc-in [::new-case-data ::new-case-complaint-ids] [(:complaint/id complaint)])
        email (update-in [::new-case-data ::new-case-complainants] (comp set conj) email)))))

(rf/reg-event-db ::select-new-case-category
  (fn [db [_ category additional-category?]]
    (let [category-entities       (entities/find-entities (entities/db->context db) (if (integer? category)
                                                                                      #{category}
                                                                                      category))
          should-skip-inspection? (-> (some #(-> %
                                                 :group.config/do-not-create-initial-inspection)
                                            category-entities)
                                      boolean)]
      (-> db (assoc-in [::new-case-data (if additional-category?
                                          ::new-additional-case-categories
                                          ::new-case-category)] category)
          (update-in [::new-case-data ::new-additional-case-categories] (fn [categories]
                                                                          (if (and (not additional-category?)
                                                                                   (some #(= % category) categories))
                                                                            (set (remove #(= % category) categories))
                                                                            categories)))
          (assoc-in [::new-case-data ::skip-initial-inspection] should-skip-inspection?)))))


(rf/reg-event-db ::change-new-case-assignee
  (fn [db [_ assignee]]
    (update db ::new-case-data assoc ::selected-new-case-assignee assignee ::assignee-changed? true)))


(rf/reg-event-db ::change-inspection-type
  (fn [db [_ inspection-type]]
    (update db ::new-case-data assoc ::selected-inspection-type inspection-type ::inspection-type-changed? true)))


(rf/reg-event-db ::select-booking-date
  (fn [db [_ date]]
    (assoc-in db [::new-case-data ::selected-date] date)))


(rf/reg-event-db ::select-booking-time-slot
  (fn [db [_ time-slot]]
    (assoc-in db [::new-case-data ::selected-time-slot] time-slot)))


(rf/reg-event-db ::clear-booking-time-slot
  (fn [db _]
    (assoc-in db [::new-case-data ::selected-time-slot] nil)))


(rf/reg-event-db ::disable-default-optional-vals
  (fn [db _]
    (assoc-in db [::new-case-data ::default-optional-vals?] false)))


(rf/reg-event-db ::move-to-case
  (fn [db _]
    (assoc-in db [::new-case-data ::move-to-case?] true)))


(rf/reg-event-db ::set-new-case-property
  (fn [db [_ property]]
    (assoc-in db [::new-case-data ::new-case-property] property)))


(rf/reg-event-db ::set-new-case-location
  (fn [db [_ location]]
    (assoc-in db [::new-case-data ::new-case-location] location)))


(rf/reg-sub ::new-case-data :-> ::new-case-data)


(rf/reg-sub ::selected-case-photos
  :<- [::new-case-data]
  :-> ::selected-case-photos)


(rf/reg-event-db ::add-case-photo
  (fn [db [_ file-id]]
    (update-in db [::new-case-data ::selected-case-photos] (comp set conj) file-id)))


(rf/reg-event-db ::remove-case-photo
  (fn [db [_ file-id]]
    (update-in db [::new-case-data ::selected-case-photos] (comp set disj) file-id)))


(rf/reg-event-fx ::remove-all-complaint-photos
  (fn [_ [_ photo-ids]]
    {:fx (map (fn [photo] [:dispatch [::remove-case-photo photo]]) photo-ids)}))


(rf/reg-event-fx ::select-all-complaint-photos
  (fn [_ [_ photo-ids]]
    {:fx (map (fn [photo] [:dispatch [::add-case-photo photo]]) photo-ids)}))


(rf/reg-sub ::new-case-group
  :<- [::new-case-data]
  :<- [::entities/context]
  (fn [[new-case-data ctx] _]
    (when-let [id (::authority-group-id new-case-data)]
      (entities/find-entity ctx id))))


(rf/reg-sub ::create-modal-open?
  :<- [::new-case-data]
  :-> ::create-modal-open?)


(rf/reg-sub ::optional-params-modal-open?
  :<- [::new-case-data]
  :-> ::optional-params-modal-open?)


(rf/reg-sub ::loading?
  :<- [::creating-case?]
  :<- [::fetching-assignees?]
  :<- [::fetching-inspections?]
  :<- [::fetching-complaints?]
  (fn [[case? assignees? inspections? complaints?] _]
    (or case? assignees? inspections? complaints?)))


(rf/reg-sub ::new-case-selected-category
  :<- [::new-case-data]
  :-> ::new-case-category)

(rf/reg-sub ::selected-additional-case-categories
  :<- [::new-case-data]
  :-> ::new-additional-case-categories)

(rf/reg-sub ::new-case-complaints
  :<- [::new-case-data]
  :<- [::entities/context]
  (fn [[data ctx] _]
    (->> data
         ::new-case-complaint-ids
         (map #(entities/find-entity ctx {:complaint/id %}))
         (filter (du/in-state-fn :complaint.state/open)))))


(rf/reg-sub ::complaint-photos-count
  :<- [::new-case-complaints]
  :<- [::entities/context]
  (fn [[complaints ctx] _]
    (let [complaint-photo-parents (->> (entities/find-entities ctx {:entity/type   :entity.type/file
                                                                    :file/category :file.category/complaint-photo})
                                       (map :entity/parent)
                                       (map :db/id))
          complaint-db-ids        (->> complaints (map :db/id))]
      (->> complaint-photo-parents
           (filter (set complaint-db-ids))
           count))))





(rf/reg-sub ::new-case-default-category-id
  :<- [::new-case-complaints]
  :<- [::complaint-subs/available-categories]
  (fn [[complaints categories] _]
    (-> (or (when-let [category (-> complaints
                                    first
                                    :complaint/category-group-config)]
              (assert (entity-api/entity? category) "category from complaint must be an entity")
              category)
            (first categories))
        :db/id)))

(rf/reg-sub ::category-has-add-complainant-flag?
  :<- [::new-case-selected-category]
  :<- [::new-case-default-category-id]
  :<- [::entities/context]
  (fn [[selected-category default-category ctx] _]
    (when-let [category-id (or selected-category default-category)]
      (let [category (entities/find-entity ctx category-id)]
        (boolean (config-model/resolve-config-value :group.config/add-complainant-as-related-party? category))))))


(rf/reg-sub ::complainants
  :<- [::new-case-complaints]
  (fn [complaints]
    (->> complaints
         (keep :complaint/complainer-email)
         set)))

(rf/reg-sub ::new-case-complainants
  :<- [::new-case-data]
  :-> ::new-case-complainants)

(rf/reg-sub ::has-complainant?
  :<- [::new-case-complainants]
  (fn [complainants [_ complainant]]
    (contains? complainants complainant)))

(rf/reg-event-db ::update-new-case-complainants-list
  (fn [db [_ add? complainant]]
    (if (str/blank? complainant)
      db
      (let [operation (comp set (if add? conj disj))]
        (update-in db [::new-case-data ::new-case-complainants] operation complainant)))))


(rf/reg-event-db ::set-skip-initial-inspection
  (fn [db [_ value]]
    (update db ::new-case-data assoc ::skip-initial-inspection value)))


(rf/reg-sub ::skip-inspection-for-selected-category?
  :<- [::new-case-selected-category]
  :<- [::new-case-default-category-id]
  :<- [::entities/context]
  (fn [[selected-category default-category ctx] _]
    (->> (or selected-category default-category)
         (entities/find-entity ctx)
         :group.config/do-not-create-initial-inspection
         boolean)))


(rf/reg-sub ::skip-initial-inspection
  :<- [::new-case-data]
  :<- [::skip-inspection-for-selected-category?]
  (fn [[data skip-for-selected?]]
    (if-some [user-set-skip (-> data ::skip-initial-inspection)]
      user-set-skip
      skip-for-selected?)))


(rf/reg-event-db ::change-case-content-view
  (fn [db [_ value]]
    (update db ::new-case-data assoc ::current-case-content-view value)))


(rf/reg-sub ::current-case-content-view
  :<- [::new-case-data]
  :-> ::current-case-content-view)


(rf/reg-sub ::new-case-complaint-info
  :<- [::new-case-complaints]
  (fn [complaints _]
    (when (= (count complaints) 1)
      (-> complaints
          first
          (select-keys [:complaint/description :complaint/severity])))))


(defn default-description-of-location [complaints]
  (when (= (count complaints) 1)
    (-> complaints first :complaint/description-of-location)))


(rf/reg-sub ::new-case-complaint-description-of-location
  :<- [::new-case-complaints]
  :-> default-description-of-location)


(rf/reg-sub ::new-case-assignees
  :<- [::new-case-data]
  :-> ::assignees)


(rf/reg-sub ::fetching-complaints?
  :<- [::new-case-data]
  :-> ::fetching-complaints?)


(rf/reg-sub ::creating-case?
  :<- [::new-case-data]
  :-> ::creating-case?)


(rf/reg-sub ::fetching-assignees?
  :<- [::new-case-data]
  :-> ::fetching-assignees?)


(rf/reg-sub ::fetching-inspections?
  :<- [::new-case-data]
  :-> ::fetching-inspections?)


(rf/reg-sub ::selected-new-case-assignee
  :<- [::new-case-data]
  :-> ::selected-new-case-assignee)


(rf/reg-sub ::new-case-execution-id
  :<- [::new-case-data]
  :-> ::execution-id)

(rf/reg-sub ::inspection-types
  :<- [::new-case-data]
  :-> ::inspection-types)


(rf/reg-sub ::selected-inspection-type
  :<- [::new-case-data]
  :-> ::selected-inspection-type)


(rf/reg-sub ::inspection-template-id
  :<- [::entities/context]
  :<- [::selected-inspection-type]
  :<- [::inspection-types]
  (fn [[ctx type types]]
    (let [inspection-type (or type (first types))]
      (-> (entities/find-entity ctx {:entity/type   :entity.type/inspection-template
                                     :entity/parent (:db/id inspection-type)})
          :db/id))))


(rf/reg-sub ::group-availability
  :<- [::new-case-group]
  (fn [group _]
    (if (group-model/superdomain-calendar? group)
      (booking-model/group-availability (group-model/group-superdomain group))
      (booking-model/group-availability group))))


(rf/reg-sub ::time-slots
  :<- [::group-availability]
  :-> :availability/time-slots)


(rf/reg-sub ::selected-time-slot
  :<- [::new-case-data]
  :-> ::selected-time-slot)


(rf/reg-sub ::selected-date
  :<- [::new-case-data]
  :-> ::selected-date)


(rf/reg-sub ::blackouts
  :<- [::new-case-group]
  :-> blackout-model/current-group-blackouts)


(rf/reg-sub ::timezone
  :<- [::new-case-data]
  :-> ::timezone)


(rf/reg-sub ::slots-for-day
  :<- [::selected-date]
  :<- [::time-slots]
  (fn [[date time-slots] _]
    (slots-for-day (or date (js/Date.)) time-slots)))


(rf/reg-sub ::default-time-slot-id
  :<- [::slots-for-day]
  #(-> % first :db/id))


(rf/reg-sub ::default-inspection-id
  :<- [::new-case-data]
  :-> ::default-inspection-id)


(rf/reg-sub ::default-optional-vals?
  :<- [::new-case-data]
  :-> ::default-optional-vals?)


(rf/reg-sub ::inspection-type-changed?
  :<- [::new-case-data]
  :-> ::inspection-type-changed?)


(rf/reg-sub ::assignee-changed?
  :<- [::new-case-data]
  :-> ::assignee-changed?)


(rf/reg-sub ::new-case-property
  :<- [::new-case-data]
  :-> ::new-case-property)

(rf/reg-sub ::new-case-location
  :<- [::new-case-data]
  :-> ::new-case-location)

(rf/reg-sub ::complaints-geometry-point
  :<- [::new-case-complaints]
  (fn [complaints _]
    (let [x-sum   (->> complaints
                       (map #(-> % :entity/location :location.center/x))
                       (reduce +))
          y-sum   (->> complaints
                       (map #(-> % :entity/location :location.center/y))
                       (reduce +))
          divider (count complaints)]
      [(/ x-sum divider) (/ y-sum divider)])))


(rf/reg-sub ::creation-params
  :<- [::new-case-complaints]
  :<- [::desc-subs/selected-priority]
  :<- [::desc-subs/edited-description :description]
  :<- [::desc-subs/selected-in-proximity]
  :<- [::desc-subs/selected-non-owner-violation]
  :<- [::desc-subs/edited-description :description-of-location]
  :<- [::new-case-selected-category]
  :<- [::new-case-default-category-id]
  :<- [::new-case-property]
  :<- [::new-case-location]
  :<- [::complaints-geometry-point]
  :<- [::selected-case-photos]
  :<- [::selected-additional-case-categories]
  :<- [::complaint-subs/permit-type-for-case-creation]
  :<- [::new-case-complainants]
  (fn [[complaints selected-priority description in-proximity non-owner-violation description-of-location
        selected-category default-category selected-property selected-location geo-point selected-photos selected-additional-categories
        permit-type complainants]
       [_ auth-group]]
    (let [authority-group-id (:authority-group-id auth-group)
          municipality       (:municipality/number auth-group)
          country            (:municipality/country auth-group)
          property-entity    (-> complaints first :complaint/property)
          selected-location  (or selected-location
                                 (some-> complaints
                                         first
                                         :entity/location
                                         (select-keys [:location.center/x :location.center/y :location/description])))
          address            (not-empty
                               (or (:address selected-property)
                                   (some-> property-entity
                                           :property/primary-address
                                           (select-keys (keys (st/required-keys address-model/AddressSchema))))
                                   (:address selected-location)))
          property           (or
                               (:property selected-property)
                               (some-> property-entity (select-keys [:property/ward :property/id :property/type-code
                                                                     :property/legal :property/integration-id])))
          geometry-point     (or
                               (when (seq complaints) geo-point)
                               (:geometry-point selected-property)
                               (when-let [loc (:entity/location selected-location)]
                                 [(-> loc :location.center/x)
                                  (-> loc :location.center/y)]))
          {:keys [gis-id
                  gis-layer
                  geometry]} selected-property
          complaint-ids      (into #{} (map :db/id complaints))
          priority           (or selected-priority
                                 workspace-model/default-priority)
          category-id        (or selected-category default-category)
          legacy-ws-param    false]
      (p/assoc-if
        (util/mmap {:workspace/case-priority         priority
                    :workspace/case-description      description
                    :workspace/case-in-proximity     in-proximity
                    :workspace/additional-categories selected-additional-categories}
                   authority-group-id municipality country permit-type
                   complaint-ids category-id legacy-ws-param)
        :workspace/case-description-of-location (or description-of-location
                                                    (default-description-of-location complaints))
        :workspace/case-non-owner-violation (when (ptc-model/permit-types-with-non-owner-violation permit-type)
                                              non-owner-violation)
        :address address
        :property property
        :location (not-empty (dissoc selected-location :address))
        :geometry-point geometry-point
        :gis-id gis-id
        :gis-layer gis-layer
        :geometry geometry
        :complainant-emails complainants
        :selected-photos selected-photos))))

(defn category-select []
  (let [lang              (<sub [:language])
        categories        (<sub [::complaint-subs/available-categories])
        selected-category (<sub [::new-case-selected-category])
        default-category  (<sub [::new-case-default-category-id])]
    [:div.pt-2
     [ui-select/select
      {:id           "category-select"
       :allow-empty? false
       :values       (map :db/id categories)
       :value        (or selected-category default-category)
       :val->str     #(-> categories
                          (p/find-first (fn [category] (= (:db/id category) %)))
                          (config-model/localized-name lang))
       :on-change    #(>evt [::select-new-case-category % false])}]]))

(rf/reg-sub ::available-case-categories
  :<- [::complaint-subs/available-categories]
  :<- [::new-case-default-category-id]
  :<- [::new-case-selected-category]
  (fn [[available-categories default-category selected-category]]
    (if (nil? selected-category)
      (filter #(not= default-category (:db/id %)) available-categories)
      (filter #(not= selected-category (:db/id %)) available-categories))))

(defn case-category-select [tr]
  (let [lang                (<sub [:language])
        selected-categories (<sub [::selected-additional-case-categories])
        filtered-categories (<sub [::available-case-categories])]
    [:div.pt-2
     [ui-ms/multi-select
      {:id          "case-category-select"
       :label-text  (tr [:complaint/category])
       :values      (map :db/id filtered-categories)
       :value       selected-categories
       :val->str    #(-> filtered-categories
                         (p/find-first (fn [category] (= (:db/id category) %)))
                         (config-model/localized-name lang))
       :on-change   #(>evt [::select-new-case-category % true])
       :class-name  "w-full min-w-48"
       :hide-label? true}]]))


(defn priority-select [tr]
  (let [priorities        workspace-model/priorities
        selected-priority (or (<sub [::desc-subs/selected-priority])
                              workspace-model/default-priority)]
    (into
      [ui/select-pills {:on-change    #(>evt [::desc-subs/select-priority %])
                        :value        selected-priority
                        :id           "priority-select"
                        :class        "pb-6 pr-6 pt-2"
                        :option-class "uppercase"}]
      (for [priority priorities]
        {:value priority
         :text  (tr [priority])}))))


(defn description-edit [group tr]
  [:div.rounded-md.pt-2.pb-6
   [ui-rt/editor-legacy {:id                 "description-text-editor"
                         :initial-value      (<sub [::desc-subs/edited-description :description])
                         :authority-group-id (:authority-group-id group)
                         :on-change          #(rf/dispatch-sync [::desc-subs/update-edited-description :description %])
                         :required?          true
                         :label-text         (tr [:case/description-title])
                         :label-class        "text-sm"}]])


(defn description-of-location-edit [group tr]
  (let [initial-value (<sub [::new-case-complaint-description-of-location])
        edited-value  (<sub [::desc-subs/edited-description :description-of-location])
        value         (or edited-value initial-value)]
    [:div.rounded-md.pt-6.pb-6
     [ui-rt/editor-legacy {:id                 "description-of-location-text-editor"
                           :initial-value      value
                           :authority-group-id (:authority-group-id group)
                           :on-change          #(rf/dispatch-sync [::desc-subs/update-edited-description :description-of-location %])
                           :label-text         (tr [:case/description-of-location-title])
                           :label-class        "text-sm"}]]))

(defn complaint-switcher-options [photo-count]
  (if (pos? photo-count)
    [:complaint/case-info :complaint/case-photos]
    [:complaint/case-info]))


(defn case-info-section [tr group]
  (let [{:complaint/keys [description severity]} (<sub [::new-case-complaint-info])
        add-complainant-as-related-party?        (<sub [::ff/enabled? :feature-flag.id/add-complainant-as-related-party])
        ce-streamline-flag-enabled?              (<sub [::ff/enabled? :feature-flag.id/streamline-ce-admin-process])
        permit-type                              (:permit-type group)]
    [:div.mt-4
     [:div.flex.flex-row.pb-6.gap-4
      [:div
       [:label (tr [:case/priority])]
       [priority-select tr]]
      [:label (tr [(if (ff/enabled? :feature-flag.id/allow-multiple-categories-to-a-case)
                     :case/case-category
                     :complaint/category)])
       [category-select]]
      (when (and (ff/enabled? :feature-flag.id/allow-multiple-categories-to-a-case)
                 (= permit-type :permit-type/CE))
        [:label (tr [:case/additional-case-categories])
         [case-category-select tr]])]
     (when (some? description)
       [:div
        [:label (tr [:complaint/description-in-creation])
         [:h5.pt-2.pb-6 description]]])
     (when severity
       [:div
        [:label (tr [:complaint/severity-in-creation])
         [:h5.pt-2.pb-6 (tr [severity])]]])
     [description-edit group tr]
     (cc/checkbox {:id         "case-in-proximity"
                   :label-text (tr [:case/in-proximity])
                   :checked    (<sub [::desc-subs/selected-in-proximity])
                   :on-change  #(>evt [::desc-subs/set-in-proximity %])})
     (when (ptc-model/permit-types-with-non-owner-violation permit-type)
       (cc/checkbox {:id         "case-non-owner-violation"
                     :label-text (tr [:case/non-owner-violation])
                     :checked    (<sub [::desc-subs/selected-non-owner-violation])
                     :on-change  #(>evt [::desc-subs/set-non-owner-violation %])}))
     [description-of-location-edit group tr]
     (when ce-streamline-flag-enabled?
       (cc/checkbox {:id         "create-without-inspection"
                     :class-name "pb-6"
                     :label-text (tr [:case/do-not-create-initial-inspection])
                     :checked    (<sub [::skip-initial-inspection])
                     :on-change  #(>evt [::set-skip-initial-inspection %])}))
     (when (and add-complainant-as-related-party?
                (<sub [::category-has-add-complainant-flag?]))
       (let [complainants (<sub [::complainants])]
         (when (seq complainants)
           [:div
            [:label (tr [:case/add-complainants])]
            (for-frag [complainant complainants]
              (cc/checkbox {:id         (str "complainant-" (hash complainant))
                            :label-text complainant
                            :checked    (<sub [::has-complainant? complainant])
                            :on-change  #(>evt [::update-new-case-complainants-list % complainant])}))])))]))


(defn complaint-photos-section [tr complaint]
  (let [complaint-photo-entities (<sub [::entities/entities
                                        {:entity/type   :entity.type/file
                                         :file/category :file.category/complaint-photo
                                         :entity/parent (:db/id complaint)}])
        complaint-photo-ids      (<sub [::complaint-subs/complaint-photo-ids (:db/id complaint)])
        lang                     (<sub [:language])
        category-name            (config-model/localized-name (:complaint/category-group-config complaint) lang)
        complaint-date           ((<sub [::date-util/date-fn]) (:entity/created complaint))
        selected-photos          (<sub [::selected-case-photos])]
    [photo-select/photo-select (util/mmap {:on-select          #(>evt [::add-case-photo %])
                                           :on-remove          #(>evt [::remove-case-photo %])
                                           :on-select-all      #(>evt [::select-all-complaint-photos complaint-photo-ids])
                                           :on-remove-all      #(>evt [::remove-all-complaint-photos complaint-photo-ids])
                                           :available-photos   complaint-photo-entities
                                           :selected-photo-ids selected-photos
                                           :label-fn           #(str category-name ", " complaint-date)
                                           :title              (str category-name ", " complaint-date)
                                           :img-alt-fn         #(tr [:case/complaint-photo])
                                           :download-command   :file/download-complaint-photo}
                                          tr)]))

(defn case-photos-section [tr]
  (let [complaints (<sub [::new-case-complaints])]
    [:div.mt-4
     [:label (tr [:case/photos-description])]
     [:div.media-wrapper
      {:id    "ce-case-photos"
       :class "whitespace-normal"}
      (for-frag [complaint (sort-by :entity/created complaints)]
        [complaint-photos-section tr complaint])]]))

(defn create-case-modal-body [tr group]
  (let [selected-content (or (<sub [::current-case-content-view])
                             :complaint/case-info)
        photo-count      (<sub [::complaint-photos-count])
        selected-photos  (<sub [::selected-case-photos])]
    [:div
     [:div {:class "sticky top-0 bg-white z-10 -b border-b-2 border-solid border-ui-gray"}
      [ui-cs/content-switcher {:items     (complaint-switcher-options photo-count)
                               :val->str  #(case %
                                             :complaint/case-photos (tr [:complaint/case-photos] [(count selected-photos)])
                                             (tr [:complaint/case-info]))
                               :current   selected-content
                               :on-change #(>evt [::change-case-content-view %])}]]
     (case selected-content
       :complaint/case-photos
       [case-photos-section tr]

       :complaint/case-info
       [case-info-section tr group])]))


(defn create-case-modal []
  (if (<sub [::loading?])
    (cc/loading-spinner)
    (let [open?            (and (<sub [::create-modal-open?])
                                (not (<sub [::optional-params-modal-open?])))
          group            (<sub [::complaint-subs/group-for-case-creation])
          tr               (<sub [::complaint-subs/complaint-tr (:permit-type group)])
          skip-inspection? (<sub [::skip-initial-inspection])
          params           (<sub [::creation-params group])]
      [ui-modal/composed-input-modal
       {:open     open?
        :on-close close-modal}
       (cc/modal-header {:close-modal close-modal
                         :title       (tr [:case/create-title])})
       (cc/modal-body
         {:class-name "pt-0 mt-2"}
         [create-case-modal-body tr group])
       (cc/modal-footer
         {}
         (cc/button
           {:kind     :secondary
            :on-click close-modal}
           (tr [:cancel]))
         (cc/button
           {:kind     :primary
            :disabled (or (nil? group)
                          (ui-rt/empty-texts? (<sub [::desc-subs/edited-description :description])))
            :on-click #(>evt [::create-case skip-inspection? params group (tr [:case/created])])}
           (tr [:case/create])))])))


(def optional-param-wrapper
  :div.w-full.md:w-1-2.px-2.mt-3)


(defn optional-params-modal-body [tr session-user]
  (let [lang               (<sub [:language])
        assignees          (cons {:id "unassigned"}
                                 (<sub [::new-case-assignees]))
        user               (->> assignees
                                (filter #(= (:db/id %) (:db/id session-user)))
                                first)
        selected-assignee  (<sub [::selected-new-case-assignee])
        inspection-types   (<sub [::inspection-types])
        selected-type      (<sub [::selected-inspection-type])
        all-time-slots     (<sub [::time-slots])
        selected-date      (<sub [::selected-date])
        selected-time-slot (<sub [::selected-time-slot])
        group              (<sub [::new-case-group])
        tz                 (<sub [::timezone])
        blackouts          (<sub [::blackouts])
        time-slots         (<sub [::slots-for-day])
        now                (js/Date.)
        min-date           (<sub [::booking-dialog/first-allowed-date group now])
        inspector-user?    (<sub [:session/inspector-user?])]
    [:div
     [:div.pb-2
      [:b (tr [:case/optional-explanation]
              [min-date (booking-utils/time-slot-string (first time-slots) tz) (user-model/full-name user)])]]
     (when (not inspector-user?)
       [:div.pb-2
        [:strong (tr [:case/optional-inspector-note])]])
     [:div.flex.flex-wrap.-mx-2.-mt-2
      [optional-param-wrapper
       [ui/date-picker {:id          "booking-date"
                        :width       "100%"
                        :fixed?      true
                        :callback    #(do (>evt [::select-booking-date %])
                                          (>evt [::clear-booking-time-slot]))
                        :value       (or selected-date (js/Date. min-date))
                        :label-text  (tr [:case/optional-date])
                        :disabled?   (not inspector-user?)
                        :allow-date? (booking-utils/allow-date-fn tz all-time-slots blackouts)
                        :min-date    min-date}]]
      [optional-param-wrapper
       [ui-select/select {:id           "time-slot-select"
                          :class        "full-width-select"
                          :values       time-slots
                          :value        selected-time-slot
                          :label-text   (tr [:case/optional-time])
                          :allow-empty? false
                          :disabled     (not inspector-user?)
                          :val->str     #(booking-utils/time-slot-string % tz)
                          :on-change    #(do (>evt [::select-booking-time-slot %])
                                             (when (nil? selected-date)
                                               (>evt [::select-booking-date now])))}]]
      [optional-param-wrapper
       [ui-select/select {:id           "inspection-type-select"
                          :class        "full-width-select"
                          :values       inspection-types
                          :value        (or selected-type (first inspection-types))
                          :label-text   (tr [:case/optional-inspection-type])
                          :allow-empty? false
                          :disabled     (< (count inspection-types) 2)
                          :val->str     #(inspection-model/inspection-template-kind-name % lang)
                          :on-change    #(>evt [::change-inspection-type %])}]]
      [optional-param-wrapper
       [ui-select/select {:id           "assignee-select"
                          :class        "full-width-select"
                          :allow-empty? false
                          :values       assignees
                          :value        (or selected-assignee user)
                          :label-text   (tr [:case/optional-assignee])
                          :val->str     #(if (= "unassigned" (:id %))
                                           (tr [:unassigned])
                                           (user-model/full-name %))
                          :on-change    #(>evt [::change-new-case-assignee %])}]]]]))


(defn optional-params-modal []
  (let [user                     (<sub [:session/user])
        loading?                 (<sub [::loading?])
        open?                    (<sub [::optional-params-modal-open?])
        execution-id             (<sub [::new-case-execution-id])
        selected-assignee        (<sub [::selected-new-case-assignee])
        template-id              (<sub [::inspection-template-id])
        default-slot-id          (<sub [::default-time-slot-id])
        default-inspection-id    (<sub [::default-inspection-id])
        default-vals             (<sub [::default-optional-vals?])
        assignee-changed?        (<sub [::assignee-changed?])
        group                    (<sub [::complaint-subs/group-for-case-creation])
        tr                       (<sub [::complaint-subs/complaint-tr (:permit-type group)])
        inspection-type-changed? (<sub [::inspection-type-changed?])]
    (if loading?
      (cc/loading-spinner)
      [ui-modal/composed-input-modal
       {:open       open?
        :class-name "modal-overflow-visible"
        :on-close   #(close-optional-modal-fn default-vals default-slot-id execution-id
                                              default-inspection-id template-id selected-assignee
                                              assignee-changed? inspection-type-changed?)}
       (cc/modal-header {:close-modal #(close-optional-modal-fn
                                         default-vals default-slot-id execution-id
                                         default-inspection-id template-id selected-assignee
                                         assignee-changed? inspection-type-changed?)
                         :title       (tr [:case/optional-title])})
       (cc/modal-body
         {}
         [optional-params-modal-body tr user])
       (cc/modal-footer
         {}
         (cc/button
           {:kind     :secondary
            :on-click #(close-optional-modal-fn
                         default-vals default-slot-id execution-id
                         default-inspection-id template-id selected-assignee
                         assignee-changed? inspection-type-changed?)}
           (tr [:close]))
         (cc/button
           {:kind     :primary
            :on-click #(do (>evt [::move-to-case])
                           (close-optional-modal-fn
                             default-vals default-slot-id execution-id
                             default-inspection-id template-id selected-assignee
                             assignee-changed? inspection-type-changed?))}
           (tr [:case/open-new-case])))])))
